import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const roleApiUrl = `${baseApiUrl}/api/Roles`;

export async function getRoles() {
    return await httpRequest(fetchRoles.bind(this));
}

async function fetchRoles() {
    let config = getHttpHeaders();
    return await axios.get(`${roleApiUrl}`, config);
}